import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
export function WhatIf() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-375" data-mp="3olc1utyuhudk">
      <div className="mx-auto max-w-3xl" data-id="element-376" data-mp="3jtka4g3ydilu">
        <SectionHeading eyebrow="What if supporting communication felt more organized?" title="You Don’t Need Another Collection of Disconnected Activities." data-id="element-377" data-mp="3jsizudurh056" />
        <div className="mt-8 space-y-5 text-lg font-semibold leading-relaxed text-ink/85" data-id="element-378" data-mp="39wpblx7oji7k">
          <p data-id="element-379" data-mp="35t9gj5b9dpwz">
            You need a practical way to organize communication observations, choose appropriate visual supports,
            prepare meaningful activities, and plan what to do next.
          </p>
          <p data-id="element-380" data-mp="2vxg6bsl0i8id">
            When you’re supporting an autistic child, communication is about much more than requesting objects or
            repeating words.
          </p>
          <p className="rounded-2xl bg-sun-soft p-5 text-navy" data-id="element-381" data-mp="u4ib5q3rj3u9">
            It’s about creating opportunities for the child to <strong className="font-black" data-id="element-382" data-mp="1wtn2xmn1r3n">express preferences,
            communicate needs, share interests, participate in daily routines,</strong> and{" "}
            <strong className="font-black" data-id="element-383" data-mp="3o534a6meeoig">connect with the people around them.</strong>
          </p>
          <p data-id="element-384" data-mp="3t3xu3sis9dc2">But organizing all those considerations can feel overwhelming.</p>
          <p data-id="element-385" data-mp="3t60u95dngmui">
            That’s why the <strong className="font-black text-navy" data-id="element-386" data-mp="knum1lnrdmn7">Autism Communication Support Blueprint™</strong>{" "}
            brings together practical educational frameworks, visual planning tools, observation worksheets, and
            implementation resources in one organized collection.
          </p>
          <p data-id="element-387" data-mp="fx4h29j8vlt1">
            Instead of constantly starting from scratch, you’ll have structured materials you can adapt to each
            child’s strengths, preferences, communication style, and individual needs.
          </p>
        </div>
        <p className="mt-10 text-balance text-center text-2xl font-black leading-snug text-navy sm:text-3xl" data-id="element-388" data-mp="18fjjfgfft1b0">
          Imagine Having a Clearer Starting Point for Your Next Communication Support Plan.
        </p>
        <div className="mt-8" data-id="element-389" data-mp="1dbnjjsm6y5xf">
          <CtaButton label="Yes! Give me the complete Blueprint™" sub="Secure Checkout · One-Time Payment of $27" data-id="element-390" data-mp="18brju5kj10no" />
        </div>
      </div>
    </section>;
}